import React, {useState, useEffect}  from 'react';
import {Container, Alert, Table, Button} from 'react-bootstrap';
import {useNavigate, useParams} from 'react-router-dom';
import axios from 'axios';
import {apiUrl} from '../../util/Api';
import {useSelector} from 'react-redux';
import {getUserAccounts} from '../../app/slices/UserSlice';

const UserAccountList = ({refresh}) => {

  const [errors, setErrors] = useState([]);
  const [accounts, setAccounts] = useState([]);
  //const [showAddUser, setShowAddUser] = useState(false);

  let {accountKey} = useParams();
  let navigate = useNavigate();


  const currUserAccounts = useSelector(getUserAccounts);
  const currUserAccount = currUserAccounts.find(a => a.accountKey===accountKey);
  const currRoleId = currUserAccount ? currUserAccount.roleId : 0;
  const userLimit = currUserAccount ? currUserAccount.userLimit : 0;

  
  useEffect(() => {

    let options = {
      
    }
    let isAuthError = false;
    axios.post(apiUrl + '/accounts/useraccounts',
      options, {withCredentials: true})
    .then((res) => {
      if(res.data.status === 'ok') {
        if(Array.isArray(res.data.accounts)){
            setAccounts(res.data.accounts);

        }
        else {
          //nothing to show
        }
      } else {
        let errorMsgs = [];
        let redirectToLogin = false;
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'auth-expired':
            case 'auth-error':
            case 'no-auth':
            case 'no-valid-account':
            case 'no-permissions':
              //console.log('auth expired');
              isAuthError = true;
              //navigate('/login');
              //errorMsgs.push('You have been logged out.');
              //return;
              redirectToLogin = true;
              break;
            case 'no-results':
              //console.log('no results')
              errorMsgs.push('You currently do not belong to any accounts..');
              break;
            default:
              errorMsgs.push('There was an error retrieving accounts.');
          }
        });
        //don't call setErrors if not logged in as it throws an unmounted error
        if(redirectToLogin) {
          navigate('/login');
          return;
        }
        if(!isAuthError) {
          setErrors(errorMsgs);
        }
      }
    })
    .catch((err) => {

    });
  },[navigate, accountKey, refresh]);

  const sortByAccount = () => {
    //console.log('sorting name')
    let temp = [...accounts]
    temp.sort((a,b) => (a.account < b.account) ? -1 : 1)
    setAccounts(temp);
  }
  const sortByRole = () => {
    //console.log('sorting key')
    let temp = [...accounts]
    temp.sort((a,b) => (a.role < b.role) ? -1 : 1)
    setAccounts(temp);
  }
  const sortByDate = () => {
    //console.log('sorting date')
    let temp = [...accounts]
    temp.sort((a,b) => (a.created < b.created) ? 1 : -1)
    setAccounts(temp);
  }

  return (
        <div>

          {
            errors.length > 0 ? (
              <Alert variant='primary'>
              {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
              </Alert>
            ) : (null)
          }
          {
            accounts.length > 0 ? (
                <>
                <h4 className='mt-5'>Accounts</h4>
                <div className='chart-card'>
              <Table  hover>
                <thead>
                  <tr>
                    <th><span onClick={sortByAccount} role="button">Account</span></th>
                    <th><span onClick={sortByRole} role="button">Role</span></th>
                    <th><span onClick={sortByDate} role="button">Added</span></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                {
                  accounts.map((account, i) => (
                    <tr key={'account.' + i}>
                      <td>{account.account}</td>
                      <td>{account.role}</td>
                      <td>{new Date(account.created).toLocaleDateString()}</td>
                      <td><Button href={`/account/${account.accountKey}`} variant='primary' size='sm'>select</Button></td>
                    </tr>
                  ))
                }
                </tbody>
              </Table>
              </div>
              </>
            ) : (
              null
            )
          }
        </div>
  )
}

export default UserAccountList;
